import type { NavGroup as NavGroupType } from '@/lib/navigation';
import { NavItem } from './NavItem';

export function NavGroup({ group }: { group: NavGroupType }) {
  return (
    <div className="mb-1">
      <div className="px-2.5 pb-1 pt-3 text-[10px] font-semibold uppercase tracking-[0.08em] text-subtle/90">
        {group.label}
      </div>
      <div className="space-y-px">
        {group.items.map((item) => (
          <NavItem key={item.to} item={item} />
        ))}
      </div>
    </div>
  );
}
